<template>
  <div>
    <label v-if="label" class="mb-1">{{ label }}</label>

    <b-input-group>
        <b-input-group-prepend v-if="filters.length" class="filter-prepend">
            <b-form-select
            v-model="selectedFilter"
            :options="filters"
            class="filter-select"
            />
        </b-input-group-prepend>

        <b-form-input
            :value="value"
            :placeholder="placeholder"
            @input="onInput"
            @keyup.enter="emitSearch"
        />

        <b-input-group-append>
            <b-button variant="primary" @click="emitSearch">
            Buscar
            </b-button>
        </b-input-group-append>
    </b-input-group>

  </div>
</template>

<style scoped>
.filter-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: none; /* remove seta */
  padding-right: 10px;
}
</style>


<script>
export default {
  name: 'SearchWithFilter',

  props: {
    value: String,
    placeholder: {
      type: String,
      default: 'Digite para pesquisar...'
    },
    label: String,

    filters: {
      type: Array,
      default: () => []
    },

    selectedFilterCacheKey: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      selectedFilter: (this.filters[0] ? this.filters[0].value : null)
    }
  },

  mounted() {
    if (this.selectedFilterCacheKey) {
      let selectedFilter = localStorage.getItem(this.selectedFilterCacheKey);
      if (selectedFilter) {
        let filter = this.filters.find(filter => filter.value === selectedFilter);
        if (filter) {
          this.selectedFilter = selectedFilter;
        }
      }
    }
  },

  methods: {
    onInput(val) {
      this.$emit('input', val)
    },

    emitSearch() {
      this.$emit('search', {
        value: this.value,
        filter: this.selectedFilter
      })
    },
  },

  watch: {
    selectedFilter(newValue, oldValue) {
      if (this.selectedFilterCacheKey) {
        localStorage.setItem(this.selectedFilterCacheKey, newValue);
      }
    }
  }
}
</script>
